import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import logger from "redux-logger";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import rootReducer from "../reducers/reducerIndex";
import hardSet from "redux-persist/lib/stateReconciler/hardSet";
const persistConfig = {
    key: "root",
    storage,
    stateReconciler: hardSet
    // blacklist: ["autoDataReducer"],
};

const pReducer = persistReducer(persistConfig, rootReducer);
const middleware = applyMiddleware(thunk, logger);
// if (process.env.NODE_ENV !== "dev") {

// }
const store = createStore(pReducer, middleware);
const persistor = persistStore(store);
export { persistor, store };